import React, { useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, isGuest } = useAuth()
  const navigate = useLocalizedNavigate()

  useEffect(() => {
    console.log('ProtectedRoute - user:', user, 'loading:', loading, 'isGuest:', isGuest)
    // Allow access if in guest mode OR if user is authenticated
    if (!loading && !isGuest && !user) {
      console.log('ProtectedRoute - redirecting to auth page')
      navigate('/auth')
    }
  }, [user, loading, isGuest, navigate])

  if (loading) {
    console.log('ProtectedRoute - showing loading state')
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-800 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Allow access if in guest mode OR if user is authenticated
  if (!isGuest && !user) {
    console.log('ProtectedRoute - no user and not guest, returning null')
    return null // Will redirect to auth page
  }

  console.log('ProtectedRoute - access granted, rendering children')
  return <>{children}</>
}

export default ProtectedRoute
